import React, { FC } from 'react';
import { User } from '@dynamika-shared/types/users';
import { DropdownOptionType } from './UsersTable.columns';
import { CreateUser } from '../CreateUser/CreateUser';
import { UsersListPageViewProps } from './UsersList.view';
import { DeactivateUserConfirmationModal } from '../DeactivateUser/DeactivateUserConfirmationModal';
import { ResendInvitation } from '../ResendInvitation/ResendInvitation';

export type UserListActionComponentProps = {
  actionType: DropdownOptionType;
  currentUser?: User;
  refetchUsers: UsersListPageViewProps['refetchUsers'];
  onClose: () => void;
};

export const UserListActionComponent: FC<UserListActionComponentProps> = ({
  actionType,
  currentUser,
  refetchUsers,
  onClose,
}) => {
  switch (actionType) {
    case DropdownOptionType.create:
    case DropdownOptionType.edit:
      return (
        <CreateUser
          currentUser={currentUser}
          mode={actionType}
          refetchUsers={refetchUsers}
          close={onClose}
        />
      );
    case DropdownOptionType.deactivate:
    case DropdownOptionType.reactivate:
      return (
        <DeactivateUserConfirmationModal
          onClose={onClose}
          currentUser={currentUser}
          refetchUsers={refetchUsers}
        />
      );
    case DropdownOptionType.resendInvite:
      return <ResendInvitation onClose={onClose} currentUser={currentUser} />;
    default:
      return null;
  }
};
